import React, { Component } from 'react'
import { connect } from 'react-redux'
import { generateVariableKey } from '../../../utils'
import { generateOperator } from '../../../actions/actions'
import css from './styles.scss'
import globalCss from '../../../../scss/global.scss'
import ModifiersEditor from '../ModifiersEditor'

export class FormulaEditor extends Component {
  constructor ({ variable: { args } }) {
    super()
    this.acceptableMacros = ['javascript', 'choiceFromReference', 'choiceFromAnonymous', 'randomNumber', 'number', 'getter', 'formula', 'round']
    this.freshOperation = { type: 'operator', value: '', selected: [] }
    this.freshInput = { type: 'value', value: '' }
    let steps
    if (Array.isArray(args[0])) {
      steps = args[0]
      if (steps.length > 1 && steps[steps.length - 1].type === 'operator' && steps[steps.length - 1].value !== '') {
        steps.push({ ...this.freshInput })
      } else if (steps.length < 2) {
        steps = [{ ...this.freshInput }, { ...this.freshOperation }]
      }
    } else {
      steps = [{ ...this.freshInput }, { ...this.freshOperation }]
    }

    this.state = {
      variables: steps
    }
  }

  handleRemoveLastItem = () => {
    const steps = [...this.state.variables]
    steps.splice(steps.length - 2, 2)
    const step = steps[steps.length - 1]
    if (step.value !== 'reference') {
      step.value = ''
    }
    step.selected = []
    this.setState({
      variables: steps
    })
  }

  updateStep (value, i, type) {
    const variables = [...this.state.variables]
    if (type === 'operator' && !variables[i + 1]) {
      variables.push({ ...this.freshInput }, { ...this.freshOperation })
    }
    if (type === 'operator') {
      const sel = new Set(variables[i].selected)
      if (value === 'random') {
        if (variables[i].value === 'random') {
          sel.clear()
          variables[i].value = ''
        } else {
          sel.clear()
          variables[i].value = 'random'
        }
      } else {
        if (variables[i].value === 'random') {
          if (sel.has(value)) {
            sel.delete(value)
          } else {
            sel.add(value)
          }
        } else {
          sel.clear()
          sel.add(value)
          variables[i].value = value
        }
      }
      variables[i].selected = Array.from(sel)
    }
    if (type === 'value' || type === 'reference') {
      variables[i].value = value
    }
    this.setState({
      variables
    })
  }

  toggleKeyOrIdx = idx => {
    const steps = [...this.state.variables]
    if (steps[idx].type === 'value') {
      steps[idx].type = 'reference'
    } else {
      steps[idx].type = 'value'
    }
    this.setState({
      variables: steps
    })
  }

  toggleOperatorKeyOrIdx = idx => {
    const steps = [...this.state.variables]
    steps[idx].selected = []
    if (steps[idx].value !== 'reference') {
      steps[idx].value = 'reference'
    } else {
      steps[idx].value = ''
    }
    this.setState({
      variables: steps
    })
  }

  createOperatorVariable = index => {
    const { dispatch, variableName, variable: { name } } = this.props
    const keyName = generateVariableKey()
    const newVariableName = `${name} - Operator`
    const operatorIndex = Math.floor(index / 2)
    dispatch(generateOperator(keyName, newVariableName, [variableName, operatorIndex]))
  }

  createOperatorOptions = () => {
    const options = [<option value='' key='_EMPTY_OPTION_'>Select a variable</option>]
    const { vars } = this.props
    for (const key in vars) {
      const variable = vars[key]
      if (variable.macro === 'operator') {
        options.push(
          <option value={key} key={key}>{ variable.name}</option>
        )
      }
    }
    return options
  }

  updateOperatorReference = (value, idx) => {
    const steps = [...this.state.variables]
    if (!steps[idx + 1]) {
      steps.push({ ...this.freshInput }, { ...this.freshOperation })
    }
    steps[idx].selected = [value]
    this.setState({
      variables: steps
    })
  }

  componentWillReceiveProps (nextProps) {
    const { report, save, variableName } = this.props
    if (nextProps.report === true && report === false) {
      save(variableName, [this.state.variables])
    }
  }

  componentDidUpdate (prevProps, prevState) {
    const { update } = this.props
    if (prevState !== this.state) {
      update()
    }
  }

  render () {
    const { variableName, vars, app: { primaryColor }, modifiers, instance, instanceModifiers } = this.props
    const { variables } = this.state
    const varList = [<option value='' key='_EMPTY_OPTION_'>Select a variable</option>]
    Object.keys(vars).forEach(varName => {
      if (variableName !== varName) {
        const varDeets = vars[varName]
        if (this.acceptableMacros.indexOf(varDeets.macro) > -1) {
          varList.push(
            <option value={varName} key={varName}>{varDeets.name}</option>
          )
        }
      }
    })
    const operatorOptions = this.createOperatorOptions()
    const steps = variables.map((variable, i) => {
      let remove = null
      if (i === variables.length - 2 && variables.length > 2) {
        remove = (
          <button onClick={this.handleRemoveLastItem} className={css.remove} style={{ color: primaryColor }}>
            <i className={globalCss.iconMinusCircled} />
          </button>
        )
      }
      let operatorButton = null
      if (i !== variables.length - 1) {
        operatorButton = (
          <div className={css.operatorButtonWrapper}>
            <button onClick={() => this.createOperatorVariable(i)} className={css.add}>
              Create a variable for this operator
            </button>
          </div>
        )
      }
      if (variable.type === 'operator') {
        variable.selected = variable.selected || []

        if (variable.value === 'reference') {
          const selected = variable.selected[0] || ''
          return (
            <div key={i} className={css.input}>
              <label>Operator</label>
              <span className={css.switch}>
                <button className={css.switchBtn} onClick={() => this.toggleOperatorKeyOrIdx(i)}>
                  Use an Operator
                </button>
              </span>
              <div className={css.backer}>
                <select className={css.select} value={selected} onChange={evt => this.updateOperatorReference(evt.target.value, i)}>
                  {operatorOptions}
                </select>
              </div>
            </div>
          )
        }

        return (
          <div key={i} style={ { display: 'inline-block', marginTop: '10px' } }>
          <span className={css.switch} style={ { float: 'none' } }>
            <button className={css.switchBtn} onClick={() => this.toggleOperatorKeyOrIdx(i)}>
              Use a Variable
            </button>
          </span>
          <div className={css.operators}>
            <span onClick={evt => this.updateStep('addition', i, variable.type)} className={css.oper}>
              <input onChange={evt => this.updateStep('addition', i, variable.type)} type='checkbox' checked={variable.selected.indexOf('addition') > -1} value='addition' />
              <label>
                +
              </label>
            </span>
            <span onClick={evt => this.updateStep('subtraction', i, variable.type)} className={css.oper}>
              <input onChange={evt => this.updateStep('subtraction', i, variable.type)} type='checkbox' checked={variable.selected.indexOf('subtraction') > -1} value='subtraction' />
              <label>
                -
              </label>
            </span>
            <span onClick={evt => this.updateStep('multiplication', i, variable.type)} className={css.oper}>
              <input onChange={evt => this.updateStep('multiplication', i, variable.type)} type='checkbox' checked={variable.selected.indexOf('multiplication') > -1} value='multiplication' />
              <label>
                x
              </label>
            </span>
            <span onClick={evt => this.updateStep('division', i, variable.type)} className={css.oper}>
              <input onChange={evt => this.updateStep('division', i, variable.type)} type='checkbox' checked={variable.selected.indexOf('division') > -1} value='division' />
              <label>
                /
              </label>
            </span>
            <span onClick={evt => this.updateStep('random', i, variable.type)} className={css.oper}>
              <input onChange={evt => this.updateStep('random', i, variable.type)} type='checkbox' checked={variable.value === 'random'} value='random' />
              <label>
                ?
              </label>
            </span>
            {remove}
            {operatorButton}
          </div>
          </div>
        )
      } else if (variable.type === 'reference') {
        return (
          <div key={i}>
            {remove}
            <div className={css.input}>
              <label>Enter a Number</label>
              <span className={css.switch}>
                <button onClick={() => this.toggleKeyOrIdx(i)} className={css.switchBtn}>
                  Use a Number
                </button>
              </span>
              <div className={css.backer}>
                <select value={variable.value} onChange={evt => this.updateStep(evt.target.value, i, variable.type)} className={css.select}>
                  {varList}
                </select>
              </div>

            </div>
          </div>
        )
      } else {
        return (
          <div key={i}>
            {remove}
            <div className={css.input}>
              <label>Enter a Number</label>
              <p className={css.switch}>
                <button onClick={() => this.toggleKeyOrIdx(i)} className={css.switchBtn}>Use a  Variable</button>
              </p>
              <input type='number' value={!variable.value && variable.value !== 0 ? '' : variable.value} onChange={evt => this.updateStep(evt.target.value, i, variable.type)} className={css.option} />
            </div>
          </div>
        )
      }
    })

    let instanceOption = null
    if (instance) {
      instanceOption = <ModifiersEditor instanceModifiers={instanceModifiers} isInstance />
    }

    return (
      <div>
        <ul>
          {steps}
        </ul>
        <ModifiersEditor modifiers={modifiers} />
        {instanceOption}
      </div>
    )
  }
}

const mapStateToProps = state => {
  const { app } = state
  return {
    app
  }
}

export default connect(mapStateToProps)(FormulaEditor)



// WEBPACK FOOTER //
// /app/js/components/EditVariable/FormulaEditor/index.js